export default "__VITE_ASSET__cbAcN7OL__"